module.exports = __webpack_public_path__ + "static/media/Carol Lanham Headshot_1623264636020.2875193e.jpeg";